import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Field } from 'react-final-form';
import type { FieldValidator } from 'final-form';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@/components/links';
import { TextInput } from '@/components/inputs';
import { StepSection } from '../StepSection';
import { FIELD_INSURANCE_NUMBER } from '../InsuranceReportForm.types';
import { LINKS } from '@/constants/links';
export const InsuranceNumberStep = () => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["insuranceReport", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = value => {
      if (!value) {
        return t("core:forms.error.required");
      }
      if (!value.startsWith("35")) {
        return t("insuranceReport:form.insuranceNumber.field.validationError");
      }
      if (!/^\d{10}$/.test(value)) {
        return t("insuranceReport:form.insuranceNumber.field.validationError");
      }
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const validateInsuranceNumber = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("insuranceReport:form.insuranceNumber.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link target="_blank" testId="contracts" analyticsParam="contracts" to={LINKS().contracts} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = <Trans t={t} i18nKey="insuranceReport:form.insuranceNumber.text">{t3}</Trans>;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = fieldRenderProps => <TextInput {...fieldRenderProps} label={t("insuranceReport:form.insuranceNumber.field.label")} />;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5 || $[11] !== validateInsuranceNumber) {
    t6 = <Field name={FIELD_INSURANCE_NUMBER} validate={validateInsuranceNumber}>{t5}</Field>;
    $[10] = t5;
    $[11] = validateInsuranceNumber;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t6) {
    t7 = <StepSection title={t2} anchorKey="insuranceReport.form.insuranceNumber.title" subtitle={t4}>{t6}</StepSection>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};